import { CheckCircle } from 'lucide-react';
import { mockData } from '../mock';

export const LeaderSection = () => (
  <section id="agents" className="py-20 bg-white">
    <div className="container mx-auto px-4">
      <div className="text-center mb-12">
        <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Meet Our Leader</h3>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">Dedicated to providing exceptional insurance guidance</p>
      </div>
      <div className="max-w-5xl mx-auto">
        {mockData.agents.map((agent) => (
          <div key={agent.id} className="flex flex-col md:flex-row gap-8 items-start">
            <div className="flex-1">
              <div className="mb-4">
                <h4 className="text-3xl font-bold text-gray-900 mb-2">{agent.name}</h4>
                <p className="text-lg text-blue-600 font-semibold mb-1">{agent.title}</p>
                <p className="text-sm text-gray-500">{agent.experience} experience</p>
              </div>
              <p className="text-gray-600 text-base leading-relaxed mb-5">{agent.bio}</p>
              <div className="mb-5">
                <p className="font-semibold text-sm text-gray-700 mb-2">Certifications:</p>
                <div className="space-y-1">
                  {agent.certifications.map((cert) => (
                    <div key={cert} className="flex items-center text-sm text-gray-600">
                      <CheckCircle className="h-4 w-4 text-green-600 mr-2" />
                      {cert}
                    </div>
                  ))}
                </div>
              </div>
              <div>
                <p className="font-semibold text-sm text-gray-700 mb-2">Specialties:</p>
                <div className="flex flex-wrap gap-2">
                  {agent.specialties.map((specialty) => (
                    <span key={specialty} className="px-3 py-1.5 bg-blue-50 text-blue-700 rounded-full text-sm font-medium">
                      {specialty}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            <div className="flex-shrink-0">
              <img
                src="https://customer-assets.emergentagent.com/job_insure-plus-1/artifacts/ytwcldm5_BFB_0045.jpg"
                alt="Adeen Schwartz"
                className="w-80 h-80 object-cover rounded-lg shadow-xl"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
